import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import {Container} from 'containers/types';
import Page from 'components/Page';
import {
  default as LoginRequired,
  LoginRequiredProps
} from 'components/LoginRequired';
import DetailsContent from 'components/DetailsContent';
import AgreementUserTakePhotoModal from 'components/AgreementUserTakePhotoModal';
import VisibleIf from 'components/VisibleIf';

import {MemberBox, MemberTable} from './components';

import {
  fetchMemberForDashboard,
  fetchMemberBookingSets,
  selectMemberBookingSets
} from 'ducks/users';
import {openModal, MODALS as BASE_MODALS, isModalOpen} from 'ducks/modals';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import {BOOKING_SET_DETAIL_URL, BOOKING_DETAIL_URL} from 'config/urls';

import {reverse} from 'utils/urls';

import './styles.css';
interface MemberDetailProps {
  match: {params: {memberId: number}};
  member: {
    fullName: string;
    avatarCropped: string;
    internalAvatarCropped: string;
    email: string;
    phone?: string;
    gender?: string;
    birthday?: string | null;
    nationality: {
      name: string;
      code: string;
    };
  };
  bookingSets: any;
}

class MemberDetails extends React.Component<
  Container &
    LoginRequiredProps &
    MemberDetailProps &
    ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps
> {
  componentDidMount() {
    const {memberId, locationRef} = this.props.match.params;

    this.props.requiresPermission(
      {
        locationRef,
        permission: PERMISSIONS.VIEW_MEMBER_PROFILE
      },
      () => {
        this.props.fetchMemberForDashboard({memberId, locationRef});
        this.props.fetchMemberBookingSets({memberId, locationRef});
      }
    );
  }

  redirectToBookingSetDetail = ({bookingSetId}) => {
    const {locationRef} = this.props.match.params;

    this.props.push(
      reverse(BOOKING_SET_DETAIL_URL, {locationRef, bookingSetId})
    );
  };

  redirectToBookingDetail = ({bookingId}) => {
    const {locationRef} = this.props.match.params;

    this.props.requiresPermission(
      {permission: PERMISSIONS.VIEW_BOOKING, locationRef},
      () => {
        this.props.push(reverse(BOOKING_DETAIL_URL, {locationRef, bookingId}));
      }
    );
  };

  render() {
    const {locationRef, memberId} = this.props.match.params;
    const {bookingSets, agreementUserTakePhotoModal} = this.props;

    return (
      <Page activeTab="membersList" locationRef={locationRef}>
        <VisibleIf
          permission={PERMISSIONS.VIEW_MEMBER_PROFILE}
          locationRef={locationRef}>
          <DetailsContent>
            <DetailsContent.Header>
              <span
                className="backToMembersPage colab-bold"
                onClick={() => this.props.history.goBack()}>
                {'<'} Back to Members List
              </span>
            </DetailsContent.Header>
            <DetailsContent.LeftSideBar>
              <MemberBox memberId={memberId} locationRef={locationRef} />
            </DetailsContent.LeftSideBar>
            <DetailsContent.Content>
              <MemberTable
                bookingSets={bookingSets}
                redirectToBookingSetDetail={this.redirectToBookingSetDetail}
                redirectToBookingDetail={this.redirectToBookingDetail}
              />
            </DetailsContent.Content>
          </DetailsContent>

          {agreementUserTakePhotoModal && <AgreementUserTakePhotoModal />}
        </VisibleIf>
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    bookingSets: selectMemberBookingSets(state),
    agreementUserTakePhotoModal: isModalOpen(
      state,
      BASE_MODALS.AGREEMENT_USER_TAKE_PHOTO
    )
  };
};

const mapDispatchToProps = {
  fetchMemberForDashboard,
  fetchMemberBookingSets,
  openModal,
  push,
  requiresPermission
};

export default connect(mapStateToProps, mapDispatchToProps)(
  LoginRequired(MemberDetails)
);
